import React, { Component } from 'react';
import PatternsComponent from 'components/toolbar/PatternsComponent.js';

class PatternsDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Projects can be broken apart into different patterns, shown in the <b>patterns component</b>, in the top toolbar.
              </p>
              <p>
                Each pattern can have different inputed steps, volumes and panning for the tracks.
              </p>
              <PatternsComponent sequencerEngine={this.props.sequencerEngine}/>
              <div className="clear-fix"/>
              <p>
                Patterns are represented by numbers, shown in the <b>patterns component</b>. The initial pattern in a project is named <b>1</b>.
              </p>
              <p className="sub-header">
                Pattern Copy
              </p>
              <p>
                To copy the current pattern into a new pattern, simply click the <b>+ button</b> in the pattern component.
              </p>
              <p className="sub-header">
                Pattern Delete
              </p>
              <p>
                To delete a pattern, click the <b>- button</b>.
              </p>
              <p className="sub-header">
                Pattern Switching
              </p>
              <p>
                Click the desired pattern number to switch to it.
              </p>
              <p>
                <b>Keyboard Shortcuts</b>
                <ul>
                  <li>
                    Typing a number switches to that pattern (unless you are in roll mode). 
                  </li>
                  <li>
                    Pressing the <b>= key</b> goes to the next pattern and
                    the <b>- key</b> goes to the previous pattern.  
                  </li>
                </ul>
              </p>
              <p className="sub-header">
                Pattern Ordering 
              </p>
              <p>
                You change the ordering of your patterns by <b>dragging</b> them.
              </p>
            </div>
        );
    }
}

export default PatternsDocumentation;
